import { render, staticRenderFns } from "./UpdateRemarkDialog.vue?vue&type=template&id=62e3ba9c&scoped=true"
import script from "./UpdateRemarkDialog.vue?vue&type=script&lang=js"
export * from "./UpdateRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateRemarkDialog.vue?vue&type=style&index=0&id=62e3ba9c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e3ba9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62e3ba9c')) {
      api.createRecord('62e3ba9c', component.options)
    } else {
      api.reload('62e3ba9c', component.options)
    }
    module.hot.accept("./UpdateRemarkDialog.vue?vue&type=template&id=62e3ba9c&scoped=true", function () {
      api.rerender('62e3ba9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/components/UpdateRemarkDialog.vue"
export default component.exports